import { useState } from 'react';
import { Box, Container, Tab, Tabs, Typography } from '@mui/material';

import Page from '../components/Page';
import { BatchSwapUpload, SingleSwapForm, UploadedSims } from '../sections/@dashboard/sim-swap';

const TABS = [
  { value: 'single', label: 'Single', Component: SingleSwapForm },
  { value: 'batch', label: 'Batch upload', Component: BatchSwapUpload },
  { value: 'uploaded', label: 'Uploaded SIMs', Component: UploadedSims },
];

export default function SimSwap() {
  const [tab, setTab] = useState(TABS[0].value);
  const [mounted, setMounted] = useState({ [TABS[0].value]: true });

  const handleChange = (_, value) => {
    setTab(value);
    setMounted((prev) => (prev[value] ? prev : { ...prev, [value]: true }));
  };

  return (
    <Page title="SIM Swap">
      <Container>
        <Typography variant="h4" sx={{ mb: 3 }}>
          SIM Swap
        </Typography>
        <Tabs value={tab} onChange={handleChange} sx={{ mb: 3 }}>
          {TABS.map((t) => (
            <Tab key={t.value} label={t.label} value={t.value} />
          ))}
        </Tabs>
        {TABS.map(({ value, Component }) =>
          mounted[value] ? (
            <Box key={value} sx={{ display: tab === value ? 'block' : 'none' }}>
              <Component />
            </Box>
          ) : null
        )}
      </Container>
    </Page>
  );
}
